import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'

export const GifContainer = styled.div((props) => {
  const size = stylesIf(
    props.size === 'sm',
    `
    width: 150px;
    height: 150px;
    `,
    `
    width: 260px;
    height: 260px;
    `
  )

  const background = stylesIf(
    props.background,
    `
    background: ${themeColor(props.background)};
    `
  )

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    ${background}
    & > div {
      ${size}
    }
  `
})
